export default __webpack_public_path__ + "static/pacifico-bull-resting-56619dd3a47055e33ad8aac0803b8d83.webp";